import { Box } from '@mantine/core';
import { useEffect, useState } from 'react';
import { LoadingAnimation } from '../chat/components/LoadingAnimation';
import { TurnState } from './types';

const PROCESSING_EXTENDED_THRESHOLD_MS = 5000;

function useNowWhileProcessing(active: boolean): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const interval = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [active]);
  return nowMs;
}

export function ConversationStatusBadge({
  turnState,
  firstTokenAt,
}: {
  turnState: TurnState;
  firstTokenAt: string | null;
}) {
  const nowMs = useNowWhileProcessing(turnState === 'PROCESSING');

  if (turnState === 'UNREAD') {
    return <Box w={8} h={8} bg="orange.6" style={{ borderRadius: '50%' }} aria-label="Unread" />;
  }

  const processingPastThreshold =
    turnState === 'PROCESSING' &&
    firstTokenAt !== null &&
    nowMs - new Date(firstTokenAt).getTime() >= PROCESSING_EXTENDED_THRESHOLD_MS;

  if (processingPastThreshold) {
    return <LoadingAnimation />;
  }

  return null;
}
